<template>
  <div class="luck-draw-grid">
    <img class="bg" src="./assets/img/gridBg.png" alt="" />
    <div class="grid-title">
      <template v-if="hasAward">
        <span>恭喜您获得 {{ drawCount }} 次抽奖机会！</span>
      </template>
      <template v-else>
        <span class="no-award">很遗憾，此问卷奖品已被领取完</span>
      </template>

    </div>
    <div class="grid-content-wrapper">
      <div class="grid-content clearfix">
        <div
            class="grid-item"
            v-for="(item, index) in prizeList"
            :key="index"
            :class="[item.isLuckBtn ? luckBtnClass : 'grid-box']"
        >
          <template v-if="item.isLuckBtn">
            <span @click="onStart">立即抽奖</span>
          </template>
          <template v-else>
            <luck-grid-item :item="item" />
            <div v-if="currentActiveIndex === index" class="luck-active"></div>
          </template>
        </div>
      </div>
    </div>
    <luck-award-popup v-if="showPopup" :award="currentAward" @confirm="onConfirm" @close="onClose" />
  </div>
</template>

<script>
import LuckGridItem from './LuckGridItem.vue'
import LuckAwardPopup from './LuckAwardPopup.vue'
import luck from './Luck.vue'

export default {
  name: 'LuckDrawGrid',
  components: { LuckAwardPopup, LuckGridItem },
  props: {
    hasAward: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    before: {
      type: Function,
      default: () => undefined
    },
    awards: {
      type: Array,
      default: () => []
    },
    drawCount: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      prizeList: [],
      list: [{ n: 1 }, { n: 2 }, { n: 3 }, { n: 4 }, { n: 5 }, { n: 6 }, { n: 7 }, { n: 8 }],
      currentActiveIndex: -1,
      awardIndex: -1,
      showPopup: false,
      currentAward: null,
      lotteryAward: null
    }
  },
  computed:{
    luckBtnClass(){
      let res = ['luck-btn']
      if(this.disabled  || !this.hasAward) {
        res.push('disabled-luck-btn')
      }
      return res.join(' ')
    }
  },
  methods: {
    onStart() {
      if (this.drawCount < 1) return
      if (this.disabled) return
      if (!this.hasAward) return
      if (this.isStart) return
      this.before(() => {
        this.isStart = true
        this.currentActiveIndex = 0
        this.awardIndex = -1
        this.start(50)
      }, data => {
        let { gridNo } = data
        this.lotteryAward = data
        if (data.boundStatus === 3) {
          if (data.boundFailedType === 2) {
            let flag = this.prizeList.filter(item => item.hasAward).length === 8
            if (flag) {
              this.$bus.busOption.overlay({ code: -20000, data: { message: '很遗憾，此问卷奖品已被领取完' } })
              this.currentActiveIndex = -1
              this.awardIndex = -1
              this.forcedInterrupt = true
            } else {
              const items = this.prizeList.filter(item => !item.hasAward && !item.isLuckBtn)
              gridNo = items[items.length / 2 | 0].gridNo
            }
          }

        }
        this.awardIndex = this.prizeList.findIndex(item => item.gridNo === gridNo)
      })
    },
    start(timer) {
      const execIndex = [0, 1, 2, 5, 8, 7, 6, 3]
      setTimeout(() => {
        if (this.forcedInterrupt) {
          return
        }
        const current = this.currentActiveIndex
        let num = execIndex.findIndex(idx => idx === current)
        if (num === execIndex.length - 1) {
          num = -1
        }
        this.currentActiveIndex = execIndex[num + 1]

        if (this.awardIndex > -1) {
          timer += 50
        }

        if (timer > 500 && this.awardIndex === this.currentActiveIndex) {
          setTimeout(() => {
            this.isStart = false

            this.showPopup = true
            this.currentAward =  this.lotteryAward
            this.$emit('end', this.prizeList[this.awardIndex], this.lotteryAward, this.awardIndex)
          }, 50)
          return
        }

        this.start(timer)
      }, timer)
    },
    onConfirm() {
      this.$emit('confirm', this.prizeList[this.awardIndex], this.lotteryAward, this.awardIndex)
    },
    onClose() {
      this.showPopup = false
      this.currentActiveIndex = -1
      this.awardIndex = -1
    },
    init() {
      const count = 8 + 1 // 8个奖品 + 中间抽奖按钮
      const center = (count / 2) | 0
      const list = []
      const maps = [0, 1, 2, 7, '', 3, 6, 5, 4]
      let n = 0
      while (n < count) {
        list.push({
          gridNo: maps[n],
          hasAward: false
        })
        n++
      }
      list[center].isLuckBtn = true
      const prizeList = this.list.slice()

      list.forEach(item => {
        if (item.isLuckBtn) return
        const gridNo = item.gridNo
        const award = this.awards.find(item => item.gridNo === gridNo)
        if (award) {
          Object.assign(item, award, { hasAward: true })
        }
      })
      this.prizeList = list
    }
  },
  created() {
    this.init()
  }
}
</script>

<style lang="scss">
.luck-draw-grid {
  position: relative;
  width: 279px;
  height: 312px;
  margin: 0 auto;
  box-sizing: border-box;
  user-select: none;

  img {
    max-width: 100%;
  }

  .grid-title {
    position: absolute;
    top: 16px;
    left: 0;
    right: 0;
    text-align: center;

    span {
      color: #FFE85A;
      font-size: 14px;
    }

    .no-award {
      color: #fff;
      font-size: 12px;
    }
  }

  .grid-content-wrapper {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 77px 26px 20px;

    .grid-item {
      float: left;
      width: 73px;
      height: 72px;
      text-align: center;
      background-color: #fffcf1;
      margin-right: 4px;
      margin-bottom: 4px;
      border-radius: 4px;
      padding: 10px 0;
      box-sizing: border-box;
      position: relative;

      color: #333;
      font-size: 12px;
      font-weight: 500;

      &:nth-child(3n) {
        margin-right: 0;
      }

      &.luck-btn {
        font-size: 30px;
        line-height: 32px;
        background-color: rgba(204, 204, 204, 0.25);
        color: #fff;
        padding: 4px 0;
        cursor: pointer;

        &:hover {
          opacity: 0.85;
        }
      }

      &.disabled-luck-btn {
        cursor: not-allowed;
        color: rgba(255,255,255,.65);
        &:hover {
          opacity: 1;
        }
      }
      .luck-active {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(0, 0, 0, 0.45);
        border-radius: 4px;
      }
    }
  }
}
</style>
